var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { UserSettingsChangeVerificationPopup } from './user-settings-change-verification-popup';
import { useOtpInputHandlers } from '../../hooks/use-otp-input';
import { codeExpiredErrorMessageKey } from './constants';
import { t } from '../../../../../infra/i18n';
export var UserSettingsChangeVerificationContainer = function (_a) {
    var fieldToVerifyName = _a.fieldToVerifyName, fieldToVerifyValue = _a.fieldToVerifyValue, onSubmit = _a.onSubmit, onResendCode = _a.onResendCode, isOpen = _a.isOpen, onClose = _a.onClose;
    var _b = useOtpInputHandlers(), code = _b.code, setCode = _b.setCode, status = _b.status, setStatus = _b.setStatus, reset = _b.reset;
    var handleClose = function () {
        reset();
        onClose(false);
    };
    var handleResendCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onResendCode(fieldToVerifyName)];
                case 1:
                    _a.sent();
                    reset();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (submittedCode) { return __awaiter(void 0, void 0, void 0, function () {
        var success, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setStatus('pending');
                    return [4 /*yield*/, onSubmit(fieldToVerifyName, submittedCode)];
                case 1:
                    success = _b.sent();
                    if (!success) {
                        setStatus('fail');
                        return [2 /*return*/];
                    }
                    setStatus('success');
                    setTimeout(function () {
                        reset();
                        onClose(true);
                    }, 1000);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    setStatus('fail');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var errorMessage = status === 'fail' ? t(codeExpiredErrorMessageKey) : null;
    var canRequestNewCode = status !== 'pending';
    if (!isOpen) {
        return null;
    }
    return (_jsx(UserSettingsChangeVerificationPopup, { fieldToVerifyName: fieldToVerifyName, fieldToVerifyValue: fieldToVerifyValue, code: code, setCode: setCode, status: status, canRequestNewCode: canRequestNewCode, errorMessage: errorMessage, onClose: handleClose, onResendCode: handleResendCode, onSubmit: handleSubmit }));
};
